export default __webpack_public_path__ + "static/BanImg1-2b38e7b0c8824cdd1faf60f70d0ee9aa.webp";